import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  menuItem: {
    minHeight: 30,
    height: 30,
    display: 'flex',
    alignItems: 'center',
    padding: '6px 10px',
    gap: '8px',
  },
  paperProps: {
    marginTop: 5,
    padding: '4px 0px',
    borderRadius: theme.spacing(1.5),
    border: '0.5px solid rgba(36, 36, 36, 0.05)',
    boxShadow: theme.shadows[16],
  },
}));
